import { render } from "./CampaignItem.vue?vue&type=template&id=7a42088a&scoped=true"
import script from "./CampaignItem.vue?vue&type=script&lang=js"
export * from "./CampaignItem.vue?vue&type=script&lang=js"

import "./CampaignItem.vue?vue&type=style&index=0&id=7a42088a&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a42088a"]])

export default __exports__